<template>
  <div class="deal-workflow-tree-branch">
    <div
      v-for="node in nodes"
      :key="`${node.kind}-${node.id}`"
      class="deal-workflow-tree-branch__node mb-2"
    >
      <DealWorkflowNode
        :item="node"
        :is-child="true"
        :depth="depth"
        :show-actions="true"
        :show-progress="node.kind === 'purchase_order' && !!node.progress"
        :downloading-file-id="downloadingFileId"
        @download-file="(file) => $emit('download-file', node, file)"
      >
        <template #actions>
          <slot name="node-actions" :item="node" />
        </template>
      </DealWorkflowNode>

      <DealWorkflowTreeBranch
        v-if="node.children && node.children.length"
        :nodes="node.children"
        :depth="depth + 1"
        :downloading-file-id="downloadingFileId"
        @download-file="(childNode, file) => $emit('download-file', childNode, file)"
      >
        <template #node-actions="slotProps">
          <slot name="node-actions" v-bind="slotProps" />
        </template>
      </DealWorkflowTreeBranch>
    </div>
  </div>
</template>

<script>
import DealWorkflowNode from "@/views/pages/deals/partials/DealWorkflowNode.vue";

export default {
  name: "DealWorkflowTreeBranch",
  components: { DealWorkflowNode },
  props: {
    nodes: {
      type: Array,
      default: () => [],
    },
    depth: {
      type: Number,
      default: 1,
    },
    downloadingFileId: {
      type: [Number, String],
      default: null,
    },
  },
};
</script>

<style scoped>
.deal-workflow-tree-branch__node {
  border: 1px solid #eef0f5;
  border-radius: 8px;
  background: #fafbfc;
}

.deal-workflow-tree-branch__node + .deal-workflow-tree-branch__node {
  margin-top: 8px;
}

.deal-workflow-tree-branch .deal-workflow-tree-branch {
  margin-top: 8px;
  padding-left: 8px;
}
</style>
